import _ from "lodash/lodash";

const busy = {

  namespaced: true,
  state: {
    ajaxLoadingInProgress: 0,
    routeLoadingInProgress: 0,
  },

  mutations: {

    // This mutation should only be triggered by dispatching an appropriate action
    // (deliberately uses a delayed function when disabling the loader)
    _AJAX_LOADING(state, start) {
      if (start) {
        state.ajaxLoadingInProgress++
      } else {
        if (state.ajaxLoadingInProgress > 0) {
          state.ajaxLoadingInProgress = state.ajaxLoadingInProgress - 1
        }
      }
    },

    // This mutation should only be triggered by dispatching an appropriate action
    // (deliberately uses a delayed function when disabling the loader)
    _ROUTE_LOADING(state, start) {
      if (start) {
        state.routeLoadingInProgress++
      } else {
        if (state.routeLoadingInProgress > 0) {
        state.routeLoadingInProgress = state.routeLoadingInProgress - 1
        }
      }
    }
  },

  actions: {

    ajaxLoading ({ commit }, start) {

      start = typeof start !== 'boolean' ? true : start

      if (start) {
        commit('_AJAX_LOADING', true)
      }
      else {
        _.delay(() => {
          commit('_AJAX_LOADING', false)
        }, 50)
      }
    },

    routeLoading ({ commit }, start) {

      start = typeof start !== 'boolean' ? true : start

      if (start) {
        commit('_ROUTE_LOADING', true)
      } else {
        _.delay(() => {
          commit('_ROUTE_LOADING', false)
        }, 50)
      }
    }
  },

  getters: {

    ajaxIsLoading: state => {
      return state.ajaxLoadingInProgress > 0
    },

    routeIsLoading: state => {
      return state.routeLoadingInProgress > 0
    }
  }
}

export default busy;